import axios from "axios";


export const getPosts_api = async () => {

    return await axios.get("https://api.htc-braunschweig.de/posts");
};